import {useEffect, useState} from 'react';
import {genericErrorHasOccurred} from '../../../actions/generic-error/action-creators';
import {getCardDetails, initTransaction} from '../../../actions/tabapay/browser';

export const useTabapayConfirmation = ({
    languageCode,
    csrfToken,
    dispatch,
    initCardDetails,
    initError
}) => {
    const [cardDetails, setCardDetails] = useState(initCardDetails);
    const [error, setError] = useState(initError);
    const [isSubmitting, setIsSubmitting] = useState(false);

    const catchError = err => {
        dispatch(genericErrorHasOccurred(true));

        setError(err);
    };

    useEffect(() => {
        if (!cardDetails && !error) {
            getCardDetails({languageCode})
                .then(setCardDetails)
                .catch(catchError);
        }
    }, [cardDetails, error, languageCode, setError]);


    const onSubmit = securityCode => {
        setIsSubmitting(true);

        return initTransaction({
            csrfToken,
            securityCode
        }).then(data => {
            window.location.assign(data.redirectUrl);
        }).catch(catchError);
    };

    return {
        cardDetails,
        isSubmitting,
        onSubmit
    };
};
